<template>
  <div class="r-appointment-modal">
    <Modal footer-hide v-model="show" width="652">
      <div class="password-box">
        <div class="change-password">{{ $t("customer.edit") }}</div>
        <div class="individual-account">
          {{ $t("user.subAccount") }}
        </div>
        <div class="common-flex">
          <div
            class="
              input-box
              common-flex common-align-center common-justify-between
            "
            style="margin-bottom: 10px"
          >
            <Select v-model="typeId" style="width: 145px" placeholder="">
              <Option v-for="item in type" :value="item.id" :key="item.id">{{
                item.name
              }}</Option>
            </Select>
            <input
              v-if="typeId != 3"
              :placeholder="$t('customer.please…')"
              style="width: 200px"
              v-model="params.price"
              type="number"
            />
          </div>
          <div class="overstep" v-if="tipsShow && typeId != 3">
            {{ $t("user.overstep") }}
          </div>
        </div>
        <div class="refundable" style="margin-bottom: 200px">
          <!-- {{typeId}} -->
          <div v-if="typeId == 1">
            {{ $t("user.refundable") }}:
            <span style="color: #0a4dcc">{{ editSubCopy.rechargeAmount }}</span>
          </div>
          <div v-if="typeId == 2">
            {{ $t("user.refundable") }}:
            <span style="color: #0a4dcc">{{ editSubCopy.subAmount }}</span>
          </div>
          <div v-if="typeId == 3">{{ $t("user.refundableTips") }}</div>
        </div>
        <div class="common-flex common-flex-end">
          <div class="back common-hover" @click="show = false">
            {{ $t("password.back") }}
          </div>
          <div
            class="submit common-hover"
            @click="submit"
            v-if="params.price && (typeId == 1 || typeId == 2)"
          >
            {{ $t("password.submit") }}
          </div>
          <div
            class="submit common-hover"
            @click="submit"
            v-else-if="typeId == 3"
          >
            {{ $t("password.submit") }}
          </div>
          <div class="submit common-hover" v-else style="background: #999">
            {{ $t("password.submit") }}
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "r-account-modal",
  data() {
    return {
      editSubCopy: "",
      typeId: "",
      show: false,
      tipsShow: false,
      params: {
        memberId: "", //子账号Id
        price: "", //金额
        type: "", //类型 1=>3   2=>4 5  3=>6
      },
      type: [
        {
          name: "Recharge", //余额分配
          id: 1,
        },
        {
          name: "Take back", //收回
          id: 2,
        },
        {
          name: "No limit", //无限制
          id: 3,
        },
      ],
    };
  },
  mounted() {
    console.log("editSub.usableAmount", this.editSub);
  },
  methods: {
    ...mapActions([
      "balanceDistributionAction", //提交修改
    ]),
    // 提交
    submit() {
      if (this.typeId == 1) {
        this.params.type = 3;
      } else if (this.typeId == 2) {
        let price = this.editSub.usableAmount.replace(/[^\d.]/g, "");
        if (this.params.price == price) {
          this.params.type = 4;
        } else {
          this.params.type = 5;
        }
      } else if (this.typeId == 3) {
        this.params.type = 6;
      }
      this.params.memberId = this.editSub.memberId;
      this.params.price = Number(this.params.price);
      this.balanceDistributionAction(this.params).then((res) => {
        if (res.code == 0) {
          this.$emit("sumitSub");
        } else {
          this.$Message.error(res.message);
        }
      });
    },
  },
  watch: {
    accountShow: {
      handler(newval, oldval) {
        this.show = newval;
        this.params.price = ''
      },
      immediate: true,
    },
    editSub: {
      handler(newval, oldval) {
        this.editSubCopy = newval;
      },
      immediate: true,
    },
    "params.price": {
      handler(newval, oldval) {
        let price = 0;
        if (newval) {
          if (this.typeId == 1) {
            price = this.editSub.rechargeAmount.replace(/[^\d.]/g, "");
          } else if (this.typeId == 2) {
            price = this.editSub.subAmount.replace(/[^\d.]/g, "");
          }
          if (newval > Number(price)) {
            this.tipsShow = true;
          } else {
            this.tipsShow = false;
          }
        } else {
          this.tipsShow = false;
        }
      },
      immediate: true,
    },
    show: {
      handler(newval, oldval) {
        if (newval == false) {
          this.$emit("handlerAccountShow", newval);
        }
      },
      immediate: true,
    },
  },
  props: {
    accountShow: Boolean,
    editSub: [String, Object],
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
// .r-appointment-modal{
/deep/.ivu-input {
  border: none;
}
/deep/.ivu-select-selection {
  border: none;
  background: #e6e8eb;
}
.refundable {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #999999;
  line-height: 16px;
  height: 16px;
}
.overstep {
  width: 72px;
  line-height: 21px;
  background: #c9000f;
  font-size: 12px;
  color: #fff;
  height: 21px;
  text-align: center;
  border-radius: 2px;
  margin-left: 21px;
}
.password-box {
  height: 418px;
  width: 620px;
  .back,
  .submit {
    width: 116px;
    height: 40px;
    background: #b5bac4;
    line-height: 40px;
    font-size: 14px;
    font-family: Roboto, Roboto-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
  .current-balance {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #999999;
    line-height: 16px;
  }
  .current-price {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #0a4dcc;
    line-height: 16px;
  }
  .submit {
    background: #0a4dcc;
    margin-left: 14px;
  }
  .change-password {
    font-size: 30px;
    font-weight: 700;
    text-align: left;
    font-family: Times, Times-Bold;
    color: #000000;
    line-height: 37px;
    margin-bottom: 3px;
  }
  .individual-account {
    font-size: 12px;
    font-family: Times, Times-Roman;
    font-weight: Roman;
    text-align: left;
    color: #666666;
    line-height: 14px;
    margin-bottom: 50px;
  }
  .input-box {
    height: 32px;
    width: 372px;
    border-bottom: 1px solid rgba(8, 25, 56, 0.1);
    margin-bottom: 45px;
    padding-bottom: 12px;
    div {
      width: 120px;
      font-size: 14px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 16px;
    }
    input {
      height: 20px;
      line-height: 20px;
      margin-left: 70px;
      border: none;
      outline: none;
    }
  }
}
// }
</style>


// WEBPACK FOOTER //
// src/components/r-account-modal.vue